// SAMPLE env: single-site deployment — the .NET backend serves this SPA from its own
// wwwroot, so the API is on the SAME origin. These are derived from the current origin
// at runtime, which keeps the build domain-agnostic (works on any host, no rebuild).
//
// These MUST stay ABSOLUTE. Call sites do `axios.post(`${BASE_URL}/auth/login`)` using
// the shared axios instance, which already sets baseURL = BASE_URL. Axios skips baseURL
// only when the request URL is absolute; a relative "/api" here would be prepended and
// produce "/api/api/auth/login" -> 405.
export const BASE_URL = `${window.location.origin}/api`;
export const STATIC_URL = window.location.origin;

// For local dev against a separately-run backend, override with e.g.:
// export const BASE_URL = 'http://localhost:5054/api';
// export const STATIC_URL = 'http://localhost:5054';
